import axios from '../localAxios';
import { WorkspaceMode } from './types';
import { workspacesURL } from './workspacesURLs';

type CreateWorkspaceResponse = {
  id: string;
  name: string;
  mode: WorkspaceMode;
};

export async function createWorkspace({
  workspaceName,
  isAssessmentsLibrary,
}: {
  workspaceName: string;
  isAssessmentsLibrary: boolean;
}): Promise<CreateWorkspaceResponse> {
  const url = workspacesURL();

  const result = await axios.post<CreateWorkspaceResponse>(url.href, {
    name: workspaceName.trim(),
    is_assessments_library: isAssessmentsLibrary,
  });
  return result.data;
}
